import React from 'react'
import styled from 'styled-components'
import { WasteTypeIcon } from '../../shared'

interface WasteFilterItemProps {
  selected: boolean
  name: string
  id: string
  picture?: string
  onClick: (name: string) => void
}

const WasteFilterItem: React.FC<WasteFilterItemProps> = (props) => {
  const { selected, picture, name, id, onClick } = props
  const onSelect = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    onClick(id)
  }

  return (
    <Container onClick={onSelect} selected={selected}>
      <ImageWrapper>
        <WasteTypeIcon disabled={!selected} name={name} picture={picture} />
      </ImageWrapper>
      <Name selected={selected}>{name}</Name>
      <Overlay selected={selected} />
    </Container>
  )
}

interface ContainerProps {
  selected: boolean
}

const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 4px;
  align-items: center;
  padding-top: 1px;
  cursor: pointer;
  ${({ selected }) => (!selected ? `opacity: 0.5;` : '')}
`

interface OverlayProps {
  selected: boolean
}

const Overlay = styled.div<OverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 4px;
  opacity: 0.4;
  visibility: visible;
  transition-duration: 0.2s;
  ${(props) =>
    props.selected
      ? `
    background-color: ${props.theme.color.primary};
  `
      : ''}
`

interface WithSelectedProps {
  selected: boolean
}

const ImageWrapper = styled.div`
  width: 35px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Name = styled.div<WithSelectedProps>`
  font-weight: ${({ theme }) => theme.weight.semi};
  font-size: ${({ theme }) => theme.size.smaller};
  line-height: 16px;
  text-align: center;

  max-width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ selected }) =>
    selected &&
    `
    z-index: 1;
  `}
`

export default WasteFilterItem
